import { defineMessages } from 'react-intl';

export const paymentTypesMessages = defineMessages({
  ideal: {
    id: 'paymentTypes.ideal',
    defaultMessage: 'iDEAL',
  },
  postpay: {
    id: 'paymentTypes.postpay',
    defaultMessage: 'Achteraf betalen',
  },
  installments: {
    id: 'paymentTypes.installments',
    defaultMessage: 'Betalen in termijnen',
  },
  headline: {
    id: 'paymentTypes.headline',
    defaultMessage: 'Diverse betaalmethoden',
  },
  dialog: {
    id: 'paymentTypes.dialog',
    defaultMessage: 'Bereken <link>hier</link> alvast je maandbedrag',
  },
});
